// @ vendor
const React = require('react');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');
const { withRouter } = require('react-router-dom');

// @ helpers
//const { getPublicSiteUrl } = require('core/apiURLBuilder');

// @ commons
const { formatText, getFinalTitle } = require('core/i18n').i18n;
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');

// @ components
const { BrokerProductFiltersSearch } = require('components/broker/brokerProductFiltersSearch/brokerProductFiltersSearch');
const BrokerProductAdvancedSearch = require('components/broker/brokerProductAdvancedSearch/brokerProductAdvancedSearch');
const { BrokerNoStockAccountModal }  = require('components/broker/brokerSearchResults/brokerNoStockAccountModal');
const { BrokerAttentionPlanStartingModal } = require('components/broker/brokerStartingModal/brokerAttentionPlanStartingModal');

// @actions
const BrokerProductAdvancedSearchActions = require('actions/brokerProductAdvancedSearch');
const BrokerProductFiltersSearchActions = require('actions/brokerProductFiltersSearch');
const BrokerAdvancedSearchTaggingActions = require('actions/brokerAdvancedSearchTagging');
const BrokerGetProductFileActions = require('actions/brokerGetProductFile');

//@ constants
const {
    MYPROFILE_BROKER_URL,
    MYPROFILE_BROKER_EXPLORE_URL,
    BROKER_LANDING_PG_PLACE
} = require('constants/index');

class BrokerProductAdvancedSearchView extends React.Component {
    constructor(props) {
        super(props);
        this.breadcrumb = [
            {
                text: formatText('breadcrumb-brokerInvestments'),
                url: MYPROFILE_BROKER_URL
            },
            {
                text: formatText('brokerAdvancedSearch-brokerAdvancedSearch_advancedSearchName'),
                url: ''
            }
        ];
    }

    componentDidMount() {
        this.props.resetProductFile();
        if (
            !this.props.immBrokerProductFiltersSearch.get('isOnlyOneProductSelected') &&
            !this.props.location.search
        ) {
            this.props.history.replace(MYPROFILE_BROKER_EXPLORE_URL);
        }

        if(!this.props.immBrokerProductFiltersSearch.get('isFetchingFilters') && !this.props.immBrokerProductFiltersSearch.get('successFilters')) {
            this.props.getFilters();
        }
    }

    render() {
        const {
            immStocksContracts,
            immBrokerProductAdvancedSearch,
            advancedSearchProducts,
            searchSpecificProduct,
            searchSpecificProductTracking,
            searchWithPage,
            editSearch,
            immBrokerProductFiltersSearch,
            retryCombosFilters,
            updateFiltersCombosConfiguration,
            retryAdvancedSearch,
            retryAdvancedSearchSpecificProduct
        } = this.props;

        const hasNoStockContracts = immStocksContracts.isEmpty();

        return (
            <div className="container-fluid">
                <BrokerAttentionPlanStartingModal place={BROKER_LANDING_PG_PLACE} />
                <div className="row">
                    <OKCover size="medium" section="broker" customClass="col-lg-12">
                        <OKHeaderSubPage
                            breadcrumbConfig={this.breadcrumb}
                            finalTitle={getFinalTitle('brokerAdvancedSearch-brokerAdvancedSearch_advancedSearchName')}
                        />
                    </OKCover>
                </div>
                <div className="row broker-product-advanced-search-view__content">
                    <div className="broker-product-advanced-search">
                        <div className="broker-product-advanced-search__filter">
                            <div className="grid-view__body">
                                <BrokerProductFiltersSearch
                                    advancedSearchProducts={advancedSearchProducts}
                                    searchSpecificProduct={searchSpecificProduct}
                                />
                            </div>
                        </div>
                        <BrokerProductAdvancedSearch
                            immBrokerProductAdvancedSearch={immBrokerProductAdvancedSearch}
                            advancedSearchProducts={advancedSearchProducts}
                            searchSpecificProduct={searchSpecificProduct}
                            searchSpecificProductTracking={searchSpecificProductTracking}
                            searchWithPage={searchWithPage}
                            hasNoStockContracts={hasNoStockContracts}
                            editSearch={editSearch}
                            immBrokerProductFiltersSearch={immBrokerProductFiltersSearch}
                            retryCombosFilters={retryCombosFilters}
                            updateFiltersCombosConfiguration={updateFiltersCombosConfiguration}
                            retryAdvancedSearch={retryAdvancedSearch}
                            retryAdvancedSearchSpecificProduct={retryAdvancedSearchSpecificProduct}
                        />
                    </div>
                </div>
                <BrokerNoStockAccountModal/>
            </div>
        );
    }
}

BrokerProductAdvancedSearchView.propTypes = {
    history: PropTypes.object.isRequired,
    immBrokerWatchlist: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    immBrokerProductAdvancedSearch: PropTypes.object.isRequired,
    immBrokerProductFiltersSearch: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immStocksContracts: PropTypes.object,
    getFilters: PropTypes.func.isRequired,
    advancedSearchProducts: PropTypes.func,
    editSearch: PropTypes.func,
    match: PropTypes.object.isRequired,
    searchSpecificProduct: PropTypes.func,
    searchSpecificProductTracking: PropTypes.func,
    searchWithPage: PropTypes.func,
    retryCombosFilters: PropTypes.func,
    updateFiltersCombosConfiguration: PropTypes.func,
    retryAdvancedSearch: PropTypes.func,
    retryAdvancedSearchSpecificProduct: PropTypes.func,
    resetProductFile: PropTypes.func
};


module.exports.constructor = BrokerProductAdvancedSearchView;
module.exports.BrokerProductAdvancedSearchView = connect(
    state => ({
        immBrokerWatchlist: state.brokerWatchlist,
        immBrokerProductAdvancedSearch: state.brokerProductAdvancedSearch,
        immBrokerProductFiltersSearch: state.brokerProductFiltersSearch,
        immStocksContracts: state.brokerStocksContract,
        immFlagBasedFeatures: state.flagBasedFeatures
    }),{
        getFilters: BrokerProductFiltersSearchActions.getFilters,
        advancedSearchProducts: BrokerProductAdvancedSearchActions.advancedSearchProducts,
        editSearch: BrokerProductAdvancedSearchActions.editSearch,
        searchSpecificProduct: BrokerProductAdvancedSearchActions.searchSpecificProduct,
        searchSpecificProductTracking: BrokerAdvancedSearchTaggingActions.searchSpecificProductTracking,
        searchWithPage: BrokerProductAdvancedSearchActions.searchWithPage,
        retryCombosFilters: BrokerProductFiltersSearchActions.retryCombosFilters,
        updateFiltersCombosConfiguration: BrokerProductFiltersSearchActions.updateFiltersCombosConfiguration,
        retryAdvancedSearch: BrokerProductAdvancedSearchActions.retryAdvancedSearch,
        retryAdvancedSearchSpecificProduct: BrokerProductAdvancedSearchActions.retryAdvancedSearchSpecificProduct,
        resetProductFile: BrokerGetProductFileActions.reset
    }
)(withRouter(BrokerProductAdvancedSearchView));
